import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { StyledEngineProvider } from '@mui/material';
import {enableMapSet} from 'immer';
import App from './app/App';

// third party style
import 'perfect-scrollbar/css/perfect-scrollbar.css';

enableMapSet();  // Import immer's Map support

const root = createRoot(document.getElementById('root'));

root.render(
  <StyledEngineProvider injectFirst>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StyledEngineProvider>
);
